export const makeNegative = (value: number): number => {
  return value > 0 ? -value : value;
};
